// src/pages/UsersList.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebaseConfig";

export default function UsersList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");      // ⬅️ nuevo estado de búsqueda

  const navigate = useNavigate();

  useEffect(() => {
    const cargarUsuarios = async () => {
      try {
        setLoading(true);
        setError("");

        const qRef = query(
          collection(db, "usuarios"),
          orderBy("fechaRegistro", "desc") // si pide índice, puedes quitar el orderBy
        );

        const snap = await getDocs(qRef);
        const lista = snap.docs.map((docSnap) => {
          const data = docSnap.data();
          return {
            id: docSnap.id,
            nombre: data.nombre || "",
            correo: data.correo || "",
            fechaRegistro: data.fechaRegistro?.toDate?.() || null,
            calificacionPromedio:
              typeof data.calificacionPromedio === "number"
                ? data.calificacionPromedio
                : 0,
          };
        });

        setUsers(lista);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    cargarUsuarios();
  }, []);

  const handleOpenDetail = (user) => {
    navigate(`/users/${user.id}`);
  };

  // 🔍 Filtrar por ID, nombre o correo
  const searchLower = search.trim().toLowerCase();
  const filteredUsers = users.filter((u) => {
    if (!searchLower) return true;
    const id = (u.id || "").toLowerCase();
    const nombre = (u.nombre || "").toLowerCase();
    const correo = (u.correo || "").toLowerCase();
    return (
      id.includes(searchLower) ||
      nombre.includes(searchLower) ||
      correo.includes(searchLower)
    );
  });

  if (loading) return <p>Cargando usuarios...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div>
      <h1>Usuarios</h1>

      <p style={{ marginBottom: 8 }}>Total: {users.length}</p>

      {/* 🔍 Buscador */}
      <input
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Buscar por ID, nombre o correo..."
        style={{
          marginBottom: 16,
          padding: 8,
          width: "100%",
          maxWidth: 400,
          borderRadius: 4,
          border: "1px solid #ccc",
        }}
      />

      <div style={{ overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: 14,
          }}
        >
          <thead>
            <tr>
              <th style={th}>ID</th>          {/* ⬅️ nueva columna */}
              <th style={th}>Nombre</th>
              <th style={th}>Correo</th>
              <th style={th}>Fecha registro</th>
              <th style={th}>Calificación</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((u, idx) => (
              <tr
                key={u.id}
                onClick={() => handleOpenDetail(u)}
                style={{
                  cursor: "pointer",
                  backgroundColor: idx % 2 === 0 ? "#ffffff" : "#f0f0f0",
                }}
              >
                <td style={{ ...td, fontFamily: "monospace" }}>{u.id}</td>
                <td style={td}>{u.nombre || "(sin nombre)"}</td>
                <td style={td}>{u.correo}</td>
                <td style={td}>
                  {u.fechaRegistro
                    ? u.fechaRegistro.toLocaleString()
                    : "-"}
                </td>
                <td style={td}>{u.calificacionPromedio.toFixed(1)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {searchLower && filteredUsers.length === 0 && (
        <p style={{ marginTop: 8, fontSize: 12, color: "#777" }}>
          No se encontraron usuarios con ese criterio.
        </p>
      )}
    </div>
  );
}

const th = {
  borderBottom: "1px solid #ddd",
  textAlign: "left",
  padding: "8px",
  backgroundColor: "#f5f5f5",
};

const td = {
  borderBottom: "1px solid #eee",
  padding: "8px",
};
